import axios from "axios";
import initializeAxios from "../util/Axios";

class PopupService {
  constructor() {
    initializeAxios();
  }

  async getPopups({ pageIndex, pageSize, searchTerm }) {
    const response = await axios.get("/api/popups", { params: { pageIndex, pageSize, searchTerm } });
    return response.data;
  }

  async addPopup({ image, url, width, height, size, isActive }) {
    const response = await axios.post("/api/popup/add", { image, url, width, height, size, isActive });
    return response.data;
  }

  async deletePopup(popupId) {
    const response = await axios.put("/api/popup/delete", { popupId });
    return response.data;
  }

  async updatePopup({ popupId, image, url, isActive }) {
    // PUT request with popupId in body
    const response = await axios.put("/api/popups/update", { popupId, image, url, isActive });
    return response.data;
  }

  async uploadToS3(data) {
    const formData = new FormData();
    for (let key in data) formData.append(key, data[key]);
    const response = await axios.post("/api/util/uploadimage", formData);
    return response.data;
  }
}

export default new PopupService();
